import React, { useEffect, useState, Fragment } from 'react';
import { Card, CardBody, CardTitle, CardText, Row, Col, Table } from 'reactstrap';
import ReactPlayer from 'react-player'
import { PDFObject } from 'react-pdfobject'
import MetadataForm from '../container/MetadataForm';
import DocumentMenuBarView from '../container/DocumentMenuBar';
import HttpClient from '../../utils/HttpClient';
import CommentMetadataForm from '../container/CommentMetadataForm';
import ViewComments from './view_document_page/ViewComments';
import { getTitle } from '../../utils/documentUtils';

const ContentViewer = ({ url, documents, metadata, index, strings, updateUrl, lockDoc }) => {

    const [pdfSize, setPdfSize] = useState(9);
    const [metadataSize, setMetadataSize] = useState(3);
    const [isLocked, setIsLocked] = useState(true);
    const [viewAudit, setViewAudit] = useState(false);
    const [viewComments, setViewComments] = useState(false);
    const [comment, setComment] = useState();
    const [isAnnotation, setIsAnnotation] = useState(false);
    const httpClient = new HttpClient();

    const tdStyle = {
        fontSize: 14,
        wordWrap: 'break-word'
    };

    const thStyle = {
        fontSize: 20
    }

    useEffect(() => {
        if (metadata?.id?.value) {
            httpClient.getLock(metadata.id.value).then(lock => {
                setIsLocked(!!lock?.locked_by);
            });
        }
        setComment();
        prepareComment();
    }, [metadata]);

    const changeSize = () => {
        if (pdfSize < 12) {
            setPdfSize(12);
            setMetadataSize(0);
        }
        else {
            setPdfSize(9);
            setMetadataSize(3);
        }
    }

    const getAudits = () => {
        var audit = metadata._audit;
        if (audit != null && audit.value != null) {
            return audit.value.map((a, index) => {
                return (<tr key={index}><td style={tdStyle}>{a.ts.substr(0, 16).replace('T', ' ')}</td>
                    <td style={tdStyle}>{a.user}</td><td style={tdStyle}>{a.op}</td></tr>
                )
            })
        }
    }

    const getAuditTable = () => {
        return (
            <Table>
                <thead>
                    <tr>
                        <th style={thStyle}>{strings['Time']}</th>
                        <th style={thStyle}>{strings['Name']}</th>
                        <th style={thStyle}>{strings['Action']}</th>
                    </tr>
                </thead>
                <tbody>
                    {getAudits()}
                </tbody>
            </Table>
        );
    }


    const handleLockDocument = (value) => {
        lockDoc(metadata, !value);
    }

    const prepareComment = async () => {
        const comment = await httpClient.list("Comment", { Titel: getTitle(metadata) })
        const filteredComment = comment?.find(c => metadata?.Subdocuments?.value.includes(c.serialNo));
        console.log("filteredComments", filteredComment);
        if (filteredComment) {
            const url = await httpClient.download(filteredComment._id);
            const response = await fetch(url);
            const text = await response.text();
            console.log("text", text, "id", filteredComment._id);
            setComment({ text: text, id: filteredComment._id });
        } else { setComment({}); }
    }

    const getViewer = () => {
        const mimeType = metadata['Mimetype'].value;
        if (url.startsWith("error://")) {
            return (<p><b>{url.replace("error://", "")}</b></p>);
        }
        else if (viewAudit) {
            return (getAuditTable());
        }
        else if (viewComments) {
            return (<ViewComments {...{ strings, metadata, setViewComments, comment, setComment }} />);
        }
        else if (mimeType === "application/pdf") {
            if (isAnnotation) {
                const token = sessionStorage.getItem('access_token');
                const src = "https://main.d2flwhqrsi03hx.amplifyapp.com/?to=" + token + "&id=" + metadata.id.value + "&url=" + btoa(url);  
                return (<iframe src={src} style={{ width: "100%", height: "1200px", scrolling: "yes" }}></iframe>)
            }
            else {
                return (<PDFObject url={url} fallbackLink={strings.fallbackLink} height="1200px" width="100%" />)
            }
        }
        else if (mimeType.indexOf("video/") != -1) {
            return (<ReactPlayer controls playsinline playing url={url} />)
        }
        else if (mimeType.indexOf("image/") != -1) {
            return (<img src={url} style={{ maxWidth: "100%" }} />)
        }
        else if (mimeType.indexOf("text/csv") != -1) {
            return (<embed type="text/plain" src={url} width="500" height="200"></embed>)
        }
        else if (mimeType.indexOf("text/") != -1) {
            return (<iframe src={url} style={{ width: "100%", height: "100%", scrolling: "yes" }}></iframe>)
        }
        else if (url.endsWith("pdf")) {
            return (<PDFObject url={url} fallbackLink={strings.fallbackLink} height="1200px" width="100%" />);
        }
        else {
            return (<p><b>{"Document av typ " + mimeType + " " + strings.NoRender}</b></p>);
        }
    }

    const toggleAnnotation = (e) => {
        setIsAnnotation(!isAnnotation);
    }

    if (documents && documents.length > 0)
        return (
            <Fragment>
                <Row className="d-flex d-lg-flex ">
                    <DocumentMenuBarView  {...{ pdfSize, changeSize, updateUrl, isLocked, handleLockDocument, viewAudit, setViewAudit, existingComment: !!comment?.id, viewComments, setViewComments, isAnnotation, toggleAnnotation }} />
                </Row>
                <Row className="d-flex d-lg-flex ">
                    <Col key={1} xs={{ order: 1 }} md={{ size: pdfSize, order: 1 }} tag="aside">
                        {getViewer()}
                    </Col>
                    <Col key={2} xs={{ order: 2 }} md={{ size: metadataSize, order: 2 }} tag="aside" style={metadataSize === 0 ? { display: "none" } : {}}>
                        {!viewComments ? <MetadataForm isLocked={isLocked} /> : <CommentMetadataForm />}
                    </Col>
                </Row>
            </Fragment >
        )
    else return (
        <Card>
            <CardBody>
                <CardTitle tag="h4">{strings.ViewTitle}</CardTitle>
                <CardText>
                    {strings.ViewText1}:
                    <ol>
                        <li>{strings.ViewList1}</li>
                        <li>{strings.ViewList2}</li>
                        <li>{strings.ViewList3}</li>
                        <li>{strings.ViewList4}</li>
                    </ol>
                    {strings.ViewText2}
                </CardText>
            </CardBody>
        </Card>
    )
}


export default ContentViewer;

/*
https://mmdok.s3.eu-north-1.amazonaws.com/mm0/mm0/ltl51i77-lt4wqe3v-Transaktioner_2024-02-27_22-55-27.csv?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA5O6VQL3FFUR5MW7K%2F20240310%2Feu-north-1%2Fs3%2Faws4_request&X-Amz-Date=20240310T143152Z&X-Amz-Expires=30&X-Amz-Signature=262a7e7237627170e94a1c02f6ca4717f8091fe69c4049f14ae17413eeedd02f&X-Amz-SignedHeaders=host&response-content-type=text%2Fcsv

https://mmdok.s3.eu-north-1.amazonaws.com/mm0/mm0/ltl4z4t8-text.txt?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA5O6VQL3FFUR5MW7K%2F20240310%2Feu-north-1%2Fs3%2Faws4_request&X-Amz-Date=20240310T143335Z&X-Amz-Expires=30&X-Amz-Signature=53a76a0a68af0ecac0892a9a78892dc3dde1d334f6d4e92696c3b9e21355c4b3&X-Amz-SignedHeaders=host&response-content-type=text%2Fplain

*/
